import { z } from 'zod/v4';

/**
 * One row of `GET /risk-analysis/datapoints` — the rule builder's trigger
 * picker (the asset types a rule trigger can target).
 *
 * Narrowed from the legacy `datapoints` response definition
 * (`2025-06/risk-analysis-service/routes/schemas/v3/responses.js`), which also
 * returned `type`/`fieldTypeId`/`description`/`meta`/`defaultDetails`/
 * `retracedId`: neither frontend reads anything but `id` and `name`. The legacy
 * `page`/`count`/`filter`/`sort` params are dropped for the same reason — no
 * caller sent filter or sort, and the table is a small seeded lookup.
 */
export const RiskDatapointRowSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type RiskDatapointRow = z.infer<typeof RiskDatapointRowSchema>;
